
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import DashboardPage from "@/components/dashboard/DashboardPage";
import MainLayout from "@/components/layout/MainLayout";

const Index = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Rediriger vers la page d'accueil si l'utilisateur n'est pas connecté
    if (!user) {
      navigate('/');
    }
  }, [user, navigate]);

  if (!user) {
    return null; // Évite le flash avant la redirection
  }

  return (
    <MainLayout>
      <DashboardPage />
    </MainLayout>
  );
};

export default Index;
